import {useEffect, useRef, useState, useCallback} from "react";
import RatingStars from "@/pages/home/homePageComponents/components/RatingSection/components/RatingStars/RatingStars";
import SingleRatingBox from "./components/SingleRatingBox/SingleRatingBox";
import stl from "./RatingSectionV2.module.css";
import useHelpers from "@hooks/useHelpers";
import {useTranslation} from "@i18n";

const RatingSectionV2 = (props) => {
    const ulRef = useRef(null);
    const {t} = useTranslation();
    const {createUrl} = useHelpers();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const [showPopUp, setShowPopUp] = useState(false);
    const [finalSlides, setFinalSlides] = useState(props.data.survey_list);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        checkMobileSlide();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [finalSlides]);

    const checkMobileSlide = useCallback(() => {
        let tempArr = finalSlides || [];
        if (windowWidth <= 1024) {
            if (!tempArr.some((slide) => slide.name === "mobileSlide")) {
                tempArr = [...tempArr, {name: "mobileSlide", isMobileLink: true}];
            }
        }
        setFinalSlides(tempArr);
    }, [windowWidth, finalSlides]);

    const setNewSlide = useCallback((index) => {
        setActiveSlideIndex(index);
        if (windowWidth <= 1024 && ulRef.current) {
            const readMeElement = ulRef.current.querySelector(".readMe");
            if (readMeElement) {
                const relativePosLeft =
                    readMeElement.getBoundingClientRect().left -
                    ulRef.current.getBoundingClientRect().left;
                ulRef.current.style.transform = `translate(${-1 * relativePosLeft}px, 0)`;
            }
        }
    }, [windowWidth]);

    const togglePopUp = useCallback((index) => {
        setNewSlide(index);
        setShowPopUp((prev) => !prev);
    }, [setNewSlide]);

    const {avg_rating, total_rating} = props.data;

    return (
        <>
            {!props.onlyHRating ? (
                <section className={stl.ratingSection}>
                    <div className={["container", stl.container].join(" ")}>
                        <h2 className={["big centRev", stl.DTStyle].join(" ")}>
                            {t("فخورين بعملائنا", {ns: "web_home"})}
                        </h2>
                        <div className={[stl.userReviewRP,"max-md:!px-5"].join(" ")} ref={ulRef}>
                            {finalSlides &&
                                finalSlides.length > 0 &&
                                finalSlides.map((item, i) => (
                                    <SingleRatingBox
                                        key={i}
                                        className={activeSlideIndex === i ? "readMe" : undefined}
                                        name={item.name}
                                        date={item.date}
                                        location={item.city}
                                        rating={item.rating}
                                        paragraph={item.comment}
                                        percentage={item.rate}
                                        carCondition={item.car_condition}
                                        carYear={item.car_year}
                                        carName={item.car_title}
                                        onClick={() => {
                                            togglePopUp(i);
                                        }}
                                        isMobileLink={item.isMobileLink}
                                    />
                                ))}
                        </div>
                        <a href={createUrl("/feedback")}>
              <span
                  className={["m-hide", "whtBtn", stl.morereviewPr].join(" ")}
              >
                {t("اعرض المزيد", {ns: "web_common"})}
              </span>
                        </a>
                    </div>
                </section>
            ) : (
                <div className={["mobileRatingHeader", stl.revampedContainer].join(" ")}>
                    <div>
                        <strong>{t("تقييم العملاء", {ns: "web_home"})}</strong>
                        <p>
                            {total_rating} {t("تقييم", {ns: "web_home"})}
                        </p>
                    </div>
                    <div className="mobileRatingCopy">
                        <strong>{avg_rating}</strong>
                        <RatingStars
                            starHeight="26px"
                            containerWidth="145px"
                            ratingPercent={`${(avg_rating / 5) * 100}%`}
                        />
                    </div>
                </div>
            )}

            {showPopUp && (
                <div
                    className={stl.popUpURPContainer}
                    onClick={(e) => {
                        if (e.target === e.currentTarget) togglePopUp(activeSlideIndex);
                    }}
                >
                    <div className={stl.URPContent}>
                        <SingleRatingBox
                            closeFunction={() => {
                                togglePopUp(activeSlideIndex);
                            }}
                            name={finalSlides[activeSlideIndex].name}
                            date={finalSlides[activeSlideIndex].date}
                            location={finalSlides[activeSlideIndex].city}
                            rating={finalSlides[activeSlideIndex].rating}
                            paragraph={finalSlides[activeSlideIndex].comment}
                            percentage={finalSlides[activeSlideIndex].rate}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default RatingSectionV2;
